'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  top: -35px;\n  left: calc(50% - 35px);\n  @media (min-width: ', ') {\n    display: ', ';\n  }\n'], ['\n  position: absolute;\n  top: -35px;\n  left: calc(50% - 35px);\n  @media (min-width: ', ') {\n    display: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _OhioLogoSVG = require('../../../svg/OhioLogoSVG');

var _OhioLogoSVG2 = _interopRequireDefault(_OhioLogoSVG);

var _config = require('../../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BadgeContainer = _styledComponents2.default.div(_templateObject, _config.breakpoints.l, function (props) {
  return props.$visible ? 'none' : 'block';
});

BadgeContainer.displayName = 'BadgeContainer';

var Badge = function Badge(_ref) {
  var _ref$visible = _ref.visible,
      visible = _ref$visible === undefined ? true : _ref$visible;
  return _react2.default.createElement(
    BadgeContainer,
    {
      $visible: visible
    },
    _react2.default.createElement(_OhioLogoSVG2.default, {
      width: '70px'
    })
  );
};

Badge.displayName = 'Badge';

Badge.propTypes = {
  visible: _propTypes2.default.bool
};

exports.default = Badge;
Badge.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'Badge',
  'props': {
    'visible': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': ''
    }
  }
};